$.ready(function() {
	game.on('spin_ready', function() {
		allWilds(true);
	});

	function allWilds() {
		if (!(game.feature.active == 'freespin')) {
			return;
		}

		for (var f in game.last.matrix) {
			var one_per_reel = false;

			for (var b in game.last.matrix[f]) {
				if (game.last.matrix[f][b] === 0) {
					game.spindle.reels[f].window.symbols[b].addClass('symbol-0 loop');
				}
			}
		}
	}
});



/** WEBPACK FOOTER **
 ** ./public-src/js/allWilds.js
 **/